import React, {
  FormEvent,
  FunctionComponent,
  useCallback,
  useState,
} from 'react';

import { CardList, SubmitButton } from 'components';
import { FormGroup } from 'components/chroma';
import { HistoryDetail } from 'scenes/common/flows/policyDetails/types';
import { SingleFieldStepProps } from 'scenes/common/types';

import { HistoryCard } from './HistoryCard';

const isSelected = (
  historyDetail: HistoryDetail,
  historyDetails: HistoryDetail[]
): boolean => historyDetails.some((option) => option === historyDetail);

const anySelected = (items: HistoryDetail[]): boolean => items.length > 0;

const HistoryStep: FunctionComponent<Pick<
  SingleFieldStepProps<HistoryDetail[]>,
  'question' | 'defaultStateValue' | 'onNext'
>> = ({ question, defaultStateValue, onNext }) => {
  const [selectedHistoryDetails, setSelectedHistoryDetails] = useState(
    defaultStateValue
  );

  const onSubmit = useCallback(
    (event: FormEvent) => {
      onNext({ historyDetails: selectedHistoryDetails });
      event.preventDefault();
    },
    [onNext, selectedHistoryDetails]
  );

  const handleSelect = useCallback(
    (historyDetail: HistoryDetail) => {
      if (historyDetail === HistoryDetail.None) {
        setSelectedHistoryDetails(
          selectedHistoryDetails.includes(HistoryDetail.None)
            ? []
            : [HistoryDetail.None]
        );
        return;
      }

      const copyHistoryDetails = selectedHistoryDetails.filter(
        (item) => item !== HistoryDetail.None
      );

      const foundIndex = selectedHistoryDetails.findIndex(
        (option) => option === historyDetail
      );
      if (foundIndex > -1) {
        copyHistoryDetails.splice(foundIndex, 1);
      } else {
        copyHistoryDetails.push(historyDetail);
      }

      setSelectedHistoryDetails(copyHistoryDetails);
    },
    [selectedHistoryDetails]
  );

  return (
    <form onSubmit={onSubmit}>
      <FormGroup legend={question}>
        <CardList marginBottom="1rem">
          {Object.values(HistoryDetail).map((detail, index) => (
            <HistoryCard
              historyDetail={detail}
              key={detail}
              selected={isSelected(detail, selectedHistoryDetails)}
              onClick={() => handleSelect(detail)}
              screenReaderText={`Option ${index + 1} of ${
                Object.values(HistoryDetail).length
              }`}
            />
          ))}
        </CardList>
      </FormGroup>
      <SubmitButton enabled={anySelected(selectedHistoryDetails)}>
        Next
      </SubmitButton>
    </form>
  );
};

export default HistoryStep;
